module.exports = __webpack_public_path__ + "img/warning.474baed3.svg";